<template>
	<div style="height: 100%;">
		<page v-if="$route.path === '/PlayStay/Gift'">
			<listTemplate page-title="List" :pid="$cid.english.gift" :page-size="6" type="list"
				@article-click="articleClick"></listTemplate>

		</page>
		<router-view v-else></router-view>
	</div>
</template>
<script>
	import listTemplate from "~/components/entemplate/listTemplate.vue";

	export default {
		components: {
			listTemplate
		},
		data() {
			return {
				pid: null,
			}
		},
		methods: {
			articleClick(item) {
				this.$openNewWindow('/new/PlayStay/Gift/GiftDetail?id=' + item.id);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/english/PlayStay/Gift.vue